import React from "react";
import "../src/styles/App.scss";
import { Navigate, Route, Routes } from "react-router-dom";
import Home from "./domains/pages/Home";
import AddRecipient from "./domains/pages/recipient-form/AddRecipient";
import TopLoader from "./biblio/Loader/TopLoader";
import LayoutDetailsProject from "./domains/pages/layout-details-project/LayoutDetailsProject";
import AddSponsor from "./domains/pages/sponsor-form/AddSponsor";
import Projects from "./domains/pages/Projects";
import BranchProjects from "./domains/pages/BranchProjects";
import BranchProjectsList from "./domains/pages/BranchProjectsList";
import Korbas from "./domains/pages/Korbas";
import LayoutDetailsKorba from "./domains/pages/layout-details-korba/LayoutDetailsKorba";
import MoyasarResult from "./components/Moyasar/MoyasarResult";
import OurStory from "./domains/pages/menuItemLayout/OurStory";
import Login from "./domains/pages/auth/Login";
import LayoutHeader from "./biblio/Layouts/LayoutProfile";
import ProtectedRoute from "./components/utils/ProtectedRoute";
import OurBranches from "./domains/pages/WhoWeAre/OurBranches";
import News from "./domains/pages/mediaCenter/News";
import NewsDetails from "./domains/pages/mediaCenter/NewsDetails";
import PhotoAlbum from "./domains/pages/menuItemLayout/PhotoAlbum";
import VideoAlbum from "./domains/pages/menuItemLayout/VideoAlbum";
import ReportsPage from "./domains/pages/ReportsPage";
import ConditionalRenderComponents from "./components/ConditionalRenderComponents";
import AddPartnership from "./domains/pages/partnership-form/AddPartnership";
import DonationMethods from "./domains/pages/menuItemLayout/DonationMethods";
import CertificateAward from "./domains/pages/menuItemLayout/CertificateAward";
import PermitsAssociation from "./domains/pages/menuItemLayout/PermitsAssociation";
import WaitingForContentPage from "./domains/pages/WaitingForContentPage";
import PartnersList from "./domains/pages/menuItemLayout/PartnersList";
import SuggestionsComplaints from "./domains/pages/contact-us/SuggestionsComplaints";
import ExternalPrograms from "./domains/pages/external-programs/ExternalPrograms";
import ContactUs from "./domains/pages/contact-us/ContactUs";
import LayoutDetailsGeneralDonation from "./domains/pages/layout-details-general-donation/LayoutDetailsGeneralDonation";
import GeneralDonations from "./domains/pages/GeneralDonations";
import PrivacyPolicy from "./domains/pages/menuItemLayout/PrivacyPolicy";
import Survey from "./domains/pages/menuItemLayout/Survey";
import OrganizationalStructure from "./domains/pages/menuItemLayout/OrganizationalStructure";
import LayoutDetailsProgram from "./domains/pages/layout-details-program/LayoutDetailsProgram";
import LayoutDetailsPalmEdowment from "./domains/pages/layout-details-palm-endowment/LayoutDetailsPalmEdowment";
import JobsOpportunities from "./domains/pages/jobs/JobsOpportunities";
import Rating from "./components/Moyasar/Rating";
import PayProgramApplication from "./domains/pages/external-programs/PayProgramApplication";
import "@emran-alhaddad/saudi-riyal-font/index.css";
import UpdateRecipientGuard from "./domains/pages/receipient-update-form/UpdateRecipientGuard";
import ObjectivesPage from "./domains/pages/objectives/ObjectivePage";
import VisionsPage from "./domains/pages/visions/VisionsMessionsPage";

function App() {
  return (
    <div className="takaful--app-container">
      <TopLoader />
      <Routes>   
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<Home />} />
        <Route path="/national_day=true" element={<Home />} />
        <Route path="/beneficiary/add" element={<AddRecipient />} />
        <Route
          path="/beneficiary/update/:access_token"
          element={<UpdateRecipientGuard />}
        />

        <Route
          path="/project/:id"
          element={<LayoutDetailsProject />}
        />
        <Route
          path="/program/:access_token"
          element={<LayoutDetailsProgram />}
        />
        <Route path="/add-sponsor" element={<AddSponsor />} />
        <Route
          path="/korba/:access_token/:key"
          element={<LayoutDetailsKorba />}
        />
        <Route
          path="/palm-endowment/:access_token"
          element={<LayoutDetailsPalmEdowment />}
        />
        <Route
          path="/general-donation/:access_token"
          element={<LayoutDetailsGeneralDonation />}
        />
        <Route
          path="/projects"
          element={
            <Projects
              projectType="seasonal"
              title="الرئيسية"
              subtitle="المشاريع"
            />
          }
        />
        <Route path="/korbas" element={<Korbas />} />
        <Route path="/general-donations" element={<GeneralDonations />} />
        <Route path="/donation" element={<MoyasarResult />} />
        <Route path="/our-story" element={<OurStory />} />
        <Route element={<ProtectedRoute />}>
          <Route path="/profile" element={<LayoutHeader />} />
        </Route>
        <Route
          path="/seasonal-projects"
          element={
            <Projects
              key="seasonal"
              projectType="seasonal"
              title="المشاريع"
              subtitle="الموسمية"
            />
          }
        />
        <Route
          path="/general-projects"
          element={
            <Projects
              key="general"
              projectType="general"
              title="المشاريع"
              subtitle="العامة"
            />
          }
        />
        <Route path="/branch-projects" element={<BranchProjects />} />
        <Route path="/branch-projects/:branchId" element={<BranchProjectsList />} />
        <Route path="/our-branches" element={<OurBranches />} />
        <Route path="/objectives" element={<ObjectivesPage />} />
        <Route path="/vision-mission" element={<VisionsPage />} />
        <Route path="/news" element={<News />} />
        <Route path="/news/details" element={<NewsDetails />} />
        <Route path="/our-photo" element={<PhotoAlbum />} />
        <Route path="/our-video" element={<VideoAlbum />} />
        <Route path="/our-certificates-awards" element={<CertificateAward />} />

        <Route
          path="/annual-reports"
          element={<ReportsPage type="annual_reports" />}
        />
        <Route
          path="/quality-development"
          element={<ReportsPage type="quality_development" />}
        />
        <Route
          path="/performance-reports"
          element={<ReportsPage type="performance_reports" />}
        />
        <Route
          path="/regulations"
          element={<ReportsPage type="regulations" />}
        />
        <Route
          path="/operational-plans"
          element={<ReportsPage type="operational_plans" />}
        />
        <Route
          path="/financial-statement"
          element={<ReportsPage type="financial_statement" />}
        />
        <Route
          path="/goals-programs"
          element={<ReportsPage type="goals_programs" />}
        />
        <Route path="/feedback" element={<ReportsPage type="feedback" />} />
        <Route path="/officials" element={<ReportsPage type="officials" />} />
        <Route
          path="/association-data"
          element={<ReportsPage type="AssociationData" />}
        />

        <Route path="/add-partnership" element={<AddPartnership />} />
        <Route path="/donation-methods" element={<DonationMethods />} />
        <Route path="/permits-association" element={<PermitsAssociation />} />
        <Route
          path="/disclosure-transparency"
          element={
            <WaitingForContentPage
              key="disclosure-transparency"
              title="الحوكمة"
              subtitle="الإفصاح و الشفافية"
            />
          }
        />
        <Route
          path="/administrative-structure"
          element={
            <WaitingForContentPage
              key="administrative-structure"
              title="من نحن"
              subtitle="الهيكل الإداري"
            />
          }
        />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/partners" element={<PartnersList />} />
        <Route
          path="/suggestions-complaints"
          element={<SuggestionsComplaints />}
        />
        <Route path="/programs" element={<ExternalPrograms />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/evaluation" element={<Survey />} />
        <Route path="/jobs" element={<JobsOpportunities />} />
        <Route
          path="/organizational-structure"
          element={<OrganizationalStructure />}
        />
        <Route
          path="/program/application/:access_token"
          element={<PayProgramApplication />}
        />
        <Route path="/donation/rating/:access_token" element={<Home />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ConditionalRenderComponents />
      <Rating isOpe={true} setIsOpen={(v) => console.log(v)} res_id={-1} />
    </div>
  );
}

export default App;
